export const CHECKOUT_TYPES = {
  SHOW_CHECKOUT_MODAL: "SHOW_CHECKOUT_MODAL",
  HIDE_CHECKOUT_MODAL: "HIDE_CHECKOUT_MODAL"
};
